import React, { lazy, Suspense } from 'react';
import './App.css';
import { SuccessPage } from './layouts/SuccessPage/SuccesPage';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { history } from './store/store';
import Upload from './layouts/Upload/Upload';
import { useSelector } from 'react-redux';
import Modals from './components/Modals/Modals';
import reflect from './translate/translations';
import { Loader } from './shared/Loader/Loader';
import { useState } from 'react';
import { useEffect } from 'react';

const Main = lazy(() => import('./layouts/Main/Main'));

export function App() {
  const { error, lang } = useSelector((state) => state.mainState);
  const { loading: loading1 } = useSelector((state) => state.checkOtpState);
  const { loading: loading2 } = useSelector((state) => state.sendOtpState);
  const { loading: loading3 } = useSelector((state) => state.sendFileState);
  const [load, setLoading] = useState(false);
  useEffect(() => {
    if (loading1 || loading2 || loading3) {
      setLoading(true);
    } else {
      setLoading(false);
    }

    return () => {};
  }, [loading1, loading2, loading3, error]);
  reflect.lang = lang;

  return (
    <ConnectedRouter history={history}>
      <Suspense fallback={<Loader />}>
        <Modals type={error} />
        {load && <Loader />}
        <Switch>
          <Route exact path="/" component={Main} />
          <Route exact path="/success" component={SuccessPage} />
          <Route exact path="/success/visa" component={SuccessPage} />
          <Route exact path="/upload" component={Upload} />
          <Route exact path="/km" component={Upload} />
          <Route exact path="/sm" component={Upload} />
          <Route exact path="/auto" component={Upload} />
          <Route exact path="/mobi" component={Upload} />
          <Route exact path="/visa" component={Upload} />
          <Route exact path="/alifshop" component={Upload} />
          <Redirect to={'/'} />
        </Switch>
      </Suspense>
    </ConnectedRouter>
  );
}
